import ShowReceipt from "./ShowReceipt";
import ReceiptPrint from "./ReceiptPrint";

export default ShowReceipt;
export { ReceiptPrint };
